module.exports = __webpack_public_path__ + "img/pc_p2_zhengwu.e07a68d3.png";